import { render } from "./tripPrograme.vue?vue&type=template&id=578dea80&scoped=true"
import script from "./tripPrograme.vue?vue&type=script&lang=js"
export * from "./tripPrograme.vue?vue&type=script&lang=js"

import "./tripPrograme.vue?vue&type=style&index=0&id=578dea80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578dea80"]])

export default __exports__